module.exports = "<h4>Are you sure you want to delete?</h4>\r\n<mat-dialog-actions class=\"delete-buttons-div\">\r\n  <button mat-raised-button [mat-dialog-close]=\"true\" value=\"yes\" class=\"yes-btn\">Yes</button>\r\n  <button mat-button mat-dialog-close class=\"no-btn\">No</button>\r\n</mat-dialog-actions>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/delete-pop-up/delete-pop-up.component.html
// module id = ./src/app/common/delete-pop-up/delete-pop-up.component.html
// module chunks = main